export enum TRANSACTION_STATUS {
  DEBIT = 'DEBIT',
  CREDIT = 'CREDIT',
  ALL = '',
  WITHDRAW = 'WITHDRAW',
  EXCHANGE = 'EXCHANGE',
  REDEMPTION = 'REDEMPTION',
  FEE = 'FEE'
}
